import React from 'react'
import BaseFilter from '../../../components/hooks/BaseFilter'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import { Grid, IconButton } from '@material-ui/core'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { useSelector } from 'react-redux'
import { usePermissions } from '../../../hooks/usePermission'
import Icon from '@mdi/react'
import { mdiBankTransfer, mdiNoteEditOutline } from '@mdi/js'
import colors from '../../../assets/colors'

const Filter = () => {
  const styles = filterStylesComponents()
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate } = usePermissions()

  return (
    <BaseFilter>
      <Grid container spacing={3}>
        <Grid item xs={6}></Grid>
        <Grid item xs={6} className={styles.areaButtons}>
          <Grid item>
            {canCreate('bancos', permissionUser) && (
              <IconButton
                color="primary"
                variant="contained"
                component={Link}
                to="/bank/transfer"
                className={styles.btnAdd}
                style={{ backgroundColor: colors.sucess }}
              >
                <Icon path={mdiBankTransfer} size={1} />
                Transferência Bancária
              </IconButton>
            )}
          </Grid>

          <Grid item>
            {canCreate('bancos', permissionUser) && (
              <IconButton
                color="primary"
                variant="contained"
                component={Link}
                to="/bank/new"
                className={styles.btnAdd}
              >
                <Icon path={mdiNoteEditOutline} size={1} />
                Cadastrar
              </IconButton>
            )}
          </Grid>
        </Grid>
      </Grid>
    </BaseFilter>
  )
}

export default Filter
